"use client"
import useMediaQuery from "@/utils/hooks/useMediaQuery";
import { StoreLocator } from "../StoreLocator";
import UserInfo from "../UserInfo";
import UserPoints from "../UserPoints";

export default function StoreAndInfo() {
  const mediaQueryValue = useMediaQuery();
  const isMobile =
    typeof mediaQueryValue === "number" ? mediaQueryValue <= 1023 : false;
  return isMobile ? (
    <div className="flex justify-between items-center lg:hidden py-[8px] md:pt-[10px] md:pb-3">
      <StoreLocator />
      <div className="flex lg:hidden">
        <UserInfo />
      </div>
    </div>
  ) : (
    <></>
  );
}
